import { render, staticRenderFns } from "./DetailListWrapper.vue?vue&type=template&id=48ff33e3&"
import script from "./DetailListWrapper.vue?vue&type=script&lang=js&"
export * from "./DetailListWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports